import React from "react";
import Navbar from "../components/Navbar";
import HeroVenue from "../components/Hero_venue";
import Footer from "../components/Footer";
import HeaderImage from "../assets/hero_wij-01.jpg";
import Canonical from "../components/canonical";

export function Club() {
  const heroAreaName = "Our Club";

  return (
    <React.Fragment>
      <Canonical />
      <Navbar />
      <HeroVenue heroAreaName={heroAreaName} imageSrc={HeaderImage} />
      <div className="w-full bg-[#01184D] text-white content-center mx-auto">
        {/* Item 1 */}
        <div className="bg-[#075AAA] w-full mx-auto text-center flex flex-col items-center justify-center">
          <div className="max-w-[800px] flex flex-wrap items-start justify-center gap-x-4 pb-4 ">
            <h1 className="uppercase my-8 md:text-4xl text-xl sm:text-2xl ">
              Rising Sun Judo Club
            </h1>
            <p className="mx-6 md:text-xl sm:text-lg text-sm my-4">
              The Club is a registered member of the British Judo Association
              (BJA) and is run under BJA rules. Our BJA registered number is
              2501. The BJA is the only governing body for Olympic judo in the
              United Kingdom which is recognised by the Government.<br></br>
              <br></br>
              The BJA is affiliated to the Sports Council, the British Olympic
              Association, the European Judo Union, and the International Judo
              Federation.<br></br>
              <br></br>
              The British Judo Council (BJC) and the Amateur Judo Association
              (AJA) are affiliated to the British Judo Association and are the
              only other recognised judo organisations in the UK.<br></br>
              <br></br>
              The Club began in 1990. We encourage players to enter
              competitions, but we also recognise that many players prefer judo
              as a recreation rather than competing. We encourage you and work
              with you to achieve the level you want to get to in either path.
              Your ability is marked by a series of coloured belts.
            </p>
          </div>
        </div>
        <div className="bg-[#C8102E] w-full mx-auto text-center flex flex-col items-center justify-center">
          <div className="max-w-[800px] flex flex-wrap items-start justify-center ">
            <p className="mx-6 md:text-lg sm:text-base text-xs my-8">
              <b>
                Parents should note that judo is a hands-on full contact martial
                art which involves child to child and adult to child contact.
              </b>{" "}
              Judo is generally translated as “gentle” from the character “Ju”.
              However, it is never gentle, but neither is karate or taekwondo.
              Ju is often better translated as supple and requires mobility and
              movement. Judo breeds fitness, strength, self-confidence, manners,
              self- respect, and respect for others.
            </p>
          </div>
        </div>
      </div>
      <Footer year={new Date().getFullYear()} />
    </React.Fragment>
  );
}
